import { fromJS } from "immutable"
import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DIVISIONS_BY_DIMENSION_WATCHER,
} from "./constants"

export const initialState = fromJS({
  isLoadingDivisions: false,
  divisionsDrillDown: [],
  dimensions: [],
  metric: {},
  divisions: [],
})

function widgetResultByDivisionV2Reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIVISIONS_WATCHER:
      return state.set("isLoadingDivisions", true)
    case GET_DIVISIONS_BY_DIMENSION_WATCHER:
      return state.set("isLoadingDivisions", true)
    case GET_DIVISIONS_SUCCESS:
      return state
        .set("isLoadingDivisions", false)
        .set("divisionsDrillDown", action.payload.divisions_drill_down)
        .set("dimensions", action.payload.dimensions)
        .set("metric", action.payload.metric)
        .set("divisions", action.payload.divisions)

    case GET_DIVISIONS_FAILED:
      return state
        .set("isLoadingDivisions", false)
        .set("divisionsDrillDown", [])
        .set("dimensions", [])
        .set("metric", {})
        .set("divisions", [])

    default:
      return state
  }
}

export default widgetResultByDivisionV2Reducer
